import styles from "../../assets/styles/SignedUpBusinesses/SignedUpBusinesses.module.scss";
import React, { useMemo, useState } from "react";
import { AppPage, MimaButton, MimaTable, PageLoader } from "../../components";
import MimaOptionMenu from "../../components/OptionMenu/";
import { AnimatePresence } from "framer-motion";
import {
  DeleteSubDomainUrlContainer,
  UpdateBusinessContainer,
  ViewMoreContainer,
} from "../../containers/SignedUpBusinessesContainer";
import { BusinessInsightComponent as BIC } from "../../components";
import moment from "moment";
import { downloadXlsx2 } from "../../utils/download";
import constant from "../../utils/constant";
import { CgArrowsExchange } from "react-icons/cg";
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { invoiceStore } from "../../stores";
import { GiveSubscriptionContainer } from "../../containers";

const SignedUpBusinesses = ({
  options1,
  options2,
  loading,
  infoModal,
  setInfoModal,
  signedUpBusinesses,
  closeModal,
  ViewMoreModal,
  handleViewMore,
  handleApprove,
  handleListInvoices,
  handleDeleteSubdomain,
  deleteSubdomainUrlModal,
  signedupBusinessesAnalysis,
  isFetching,
  signedUpBizdata,
  isLoading,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
  setTableList,
  setIsOnlyParent,
  isOnlyParent,
  isFash,
  setIsFash,
  handleGiveSubscription,
  subscriptionModal,
  handleUpdateBusiness,
  updateBusinessModal,
}) => {
  const [data, setData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showFilter, setShowFilter] = useState(false);

  const tableData = useMemo(() => {
    if (signedUpBizdata?.status === constant.Success) {
      return signedUpBizdata?.data?.businesses || [];
    }
    return [];
  }, [signedUpBizdata]);

  const tableColumns = [
    {
      Header: "Full Name",
      Cell: ({ cell }) => {
        const firstname = cell.row.original.users?.[0]?.firstname;
        const lastname = cell.row.original.users?.[0]?.lastname;
        return <span>{`${firstname} ${lastname}`}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
    },
    {
      Header: "Phone Number",
      accessor: "mobile",
    },
    {
      Header: "Email Address",
      accessor: "email",
    },
    {
      Header: "Referred By",
      accessor: "referralSource",
    },
    {
      Header: "Buisness Category",
      accessor: "businessCategory",
      Cell: ({ cell }) => {
        const data = cell.row.original.businessCategory?.name;
        return <span>{data}</span>;
      },
    },
    {
      Header: "Website",
      Cell: ({ cell }) => {
        const website = cell.row.original.storeFrontUrl;
        return <span>{website ? website : "No Website"}</span>;
      },
    },
    {
      Header: "Created Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        const formattedDate = moment(date).format("DD/MM/YYYY hh:mm a");
        return <span>{formattedDate}</span>;
      },
    },
    {
      Header: "Last Login Date",
      Cell: ({ cell }) => {
        const lastLoginDate = cell.row.original.users?.[0]?.lastLoginDate;
        const formattedDate =
          moment(lastLoginDate).format("DD/MM/YYYY hh:mm a");
        return <span>{formattedDate}</span>;
      },
    },
    {
      Header: "Activity Status",
      accessor: "activityStatus",
      Cell: ({ cell }) => {
        const activityStatus = cell.value;
        return (
          <span
            className={`status ${activityStatus === "ACTIVE"
              ? "status__green"
              : activityStatus === "INACTIVE"
                ? "status__grey"
                : activityStatus === "BLOCKED"
                  ? "status__red"
                  : "status__dark__yellow"
              }`}
          >
            {activityStatus}
          </span>
        );
      },
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const item = cell.row.original;
        return (
          <MimaOptionMenu
            options={status === "ACTIVE" ? options2 : options1}
            onOptionSelected={(option) => {
              setData(item);
              invoiceStore.setBusiness(item);
              if (option.value === "Approve") {
                handleApprove();
              } else if (option.value === "View More") {
                handleViewMore();
              } else if (option.value === "List Invoices") {
                handleListInvoices();
              } else if (option.value === "Delete Website Url") {
                handleDeleteSubdomain();
              } else if (option.value === "Give Subscription") {
                handleGiveSubscription();
              } else if (option.value === "Update Business") {
                handleUpdateBusiness();
              }

            }}
          />
        );
      },
    },
  ];

  if (selectedIndex === 0 || selectedIndex === 2 || selectedIndex === 3) {
    tableColumns.splice(7, 0, {
      Header: "Approval Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value;
        return (
          <span
            className={`status ${status === "ACTIVE"
              ? "status__green"
              : status === "INACTIVE"
                ? "status__grey"
                : status === "BLOCKED"
                  ? "status__red"
                  : "status__dark__yellow"
              }`}
          >
            {status}
          </span>
        );
      },
    });
  }
  if (selectedIndex === 4) {
    tableColumns.splice(7, 0, {
      Header: "Subscription Expired On",
      accessor: "expiryDate",
      Cell: ({ cell }) => {
        const expiryDate = cell.row.original.subscription?.expiryDate;
        return (
          <span
            style={{
              fontWeight: "700",
              color: "var(--color-error)",
            }}
          >
            {moment(expiryDate).format("DD/MM/YY HH:mm a")}
          </span>
        );
      },
    });
  }
  if (selectedIndex === 3) {
    tableColumns.splice(7, 0, {
      Header: "Trial Expired On",
      accessor: "expiryDate",
      Cell: ({ cell }) => {
        const expiryDate = cell.row.original.subscription?.expiryDate;
        return (
          <span
            style={{
              fontWeight: "700",
              color: "var(--color-error)",
            }}
          >
            {moment(expiryDate).format("DD/MM/YY HH:mm a")}
          </span>
        );
      },
    });
  }
  if (selectedIndex === 2) {
    tableColumns.splice(7, 0, {
      Header: "Trial Ends On",
      accessor: "expiryDate",
      Cell: ({ cell }) => {
        const expiryDate = cell.row.original.subscription?.expiryDate;
        return (
          <span
            style={{
              fontWeight: "700",
              color: "var(--color-error)",
            }}
          >
            {moment(expiryDate).format("DD/MM/YY HH:mm a")}
          </span>
        );
      },
    });
  }
  if (selectedIndex === 1) {
    tableColumns.splice(
      7,
      0,
      {
        Header: "Subscription Plan",
        accessor: "name",
        Cell: ({ cell }) => {
          const plan = cell.row.original?.plan?.name;
          return <span>{plan}</span>;
        },
      },
      {
        Header: "Duration",
        accessor: "months",
        Cell: ({ cell }) => {
          const duration = cell.row.original?.subscription?.months;
          return <span>{`${duration} Month(s)`}</span>;
        },
      },
      {
        Header: "Expiry Date",
        accessor: "expiryDate",
        Cell: ({ cell }) => {
          const expiryDate = cell.row.original.subscription?.expiryDate;
          return (
            <span
              style={{
                fontWeight: "700",
                color: "var(--color-error)",
              }}
            >
              {moment(expiryDate).format("DD/MM/YY HH:mm a")}
            </span>
          );
        },
      }
    );
  }

  const navItems = [
    "All",
    "Subscribed",
    "Trial Period",
    "Trial Expired",
    "Subscription Expired",
    "3 days Inactive",
    "Potential Churn",
    "Churn",
    "Dormant",
  ];

  if (selectedIndex === 0) {
    setTableList("");
  } else if (selectedIndex === 1) {
    setTableList("Subscribed");
  } else if (selectedIndex === 2) {
    setTableList("Trial Period");
  } else if (selectedIndex === 3) {
    setTableList("Trial Expired");
  } else if (selectedIndex === 4) {
    setTableList("Expired");
  } else if (selectedIndex === 5) {
    setTableList("3 days Inactive");
  } else if (selectedIndex === 6) {
    setTableList("Potential Churn");
  } else if (selectedIndex === 7) {
    setTableList("Churn");
  } else if (selectedIndex === 8) {
    setTableList("Dormant");
  }

  // JSON to convert to Excel
  const printData = tableData.map((item) => ({
    "Business Owner":
      `${item?.users?.[0]?.firstname} ${item?.users?.[0]?.lastname}` || "",
    "Business Name": item?.tradingName || "",
    "Phone Number": item?.mobile || "",
    "Email address": item?.email || "",
    "Twitter Handle": item?.twitterHandle || "",
    "Instagram Handle": item?.instagramHandle || "",
    "Website Address": item?.Website || "",
    Plan: item?.plan?.name || "",
    "Referrer Code": item?.referredBy || "",
    "Business Category": item?.businessCategory?.name || "",
    Website: item?.storeFrontUrl || "",
    "Months Subbed for": `${item?.subscription?.months} Month(s)` || "",
    "Sub-Expiry Date":
      moment(item?.subscription?.expiryDate).format("DD/MM/YY") || "",
    "Approval Status": item?.status || "",
    "Activity Status": item?.activityStatus || "",
    "Last Login": item?.users?.[0]?.lastLoginDate || "",
    "Created Date": item?.createdAt,
  }));

  return (
    <AppPage pageTitle={"Signed-Up Business"}>
      {loading ? (
        <PageLoader title="while we load your information" />
      ) : (
        <div style={{ marginTop: "2rem" }}>
          <div className={styles.switch}>
            <div
              className={`${isFash === false ? styles.switch__show : styles.switch__show_b
                }`}
              onClick={() => {
                setIsFash(false);
              }}
            >
              Show All Businesses
            </div>
            <div
              className={`${isFash === true ? styles.switch__hide : styles.switch__hide_b
                }`}
              onClick={() => {
                setIsFash(true);
              }}
            >
              Show Fash Businesses
            </div>
          </div>
          <div className={styles.metrics}>
            <BIC
              info={
                "Total number of signed up businesses(Primary) and their secondary accounts."
              }
              title="Total Signed-up Businesses"
              amount={signedUpBusinesses.length}
              styleClass="cards_blue_1"
            />

            {signedupBusinessesAnalysis.map((analysis, i) => (
              <BIC
                info={
                  analysis.status === "ACTIVE"
                    ? "Total Number of Businesses performed transaction(s) and also used the App for up to 30 days"
                    : analysis.status === "BLOCKED"
                      ? "Total number of Businesses blocked from using Mima."
                      : analysis.status === "INACTIVE"
                        ? "Total number of Businesses signed up with no activity after 30 days."
                        : analysis.status === "TOTAL PRIMARY BUSINESES"
                          ? "Total number of primary businesses signed up on mima"
                          : analysis.status === "Total Churn"
                            ? "Total Number of Businesses that have stopped using the app"
                            : analysis.status === "Total Potential Churn"
                              ? "Total Number of Businesses that have not used the app for up to a month."
                              : analysis.status === "3 DAYS INACTIVE"
                                ? "Total Number of Businesses who haven't used the app in 3 days."
                                : analysis.status === "7 DAYS INACTIVE"
                                  ? "Total Number of Businesses who haven't used the app in 7 days."
                                  : analysis.status === "14 DAYS INACTIVE"
                                    ? "Total Number of Businesses who haven't used the app in 14 days."
                                    : "Total Number of Businesses who haven't used used the app in a 90 days"
                }
                title={analysis.status}
                amount={analysis.totalCount}
                styleClass={
                  analysis.status === "ACTIVE"
                    ? "cards_green_1"
                    : analysis.status === "BLOCKED"
                      ? "cards_red_1"
                      : analysis.status === "INACTIVE"
                        ? "cards_yellow_1"
                        : analysis.status === "TOTAL PRIMARY BUSINESES"
                          ? "cards_green_2"
                          : analysis.status === "Total Churn"
                            ? "cards_red_3"
                            : analysis.status === "Total Potential Churn"
                              ? "cards_red_4"
                              : analysis.status === "3 DAYS INACTIVE"
                                ? "cards_blue_2"
                                : analysis.status === "7 DAYS INACTIVE"
                                  ? "cards_blue_3"
                                  : analysis.status === "14 DAYS INACTIVE"
                                    ? "cards_yellow_3"
                                    : "cards_yellow_2"
                }
              />
            ))}
          </div>
          <div className={styles.filterClass}>
            <MimaButton
              icon={
                !showFilter ? (
                  <CgArrowsExchange size={30} />
                ) : (
                  <CgArrowsExchangeAlt size={30} />
                )
              }
              title={
                !showFilter ? "Showing All Records" : "Showing Only Parent"
              }
              onClick={() => {
                setIsOnlyParent(!isOnlyParent);
                setShowFilter(!showFilter);
              }}
            />
            <MimaButton
              title={`Download ${navItems[selectedIndex]} Businesses Report`}
              onClick={() => {
                downloadXlsx2(
                  printData,
                  `${navItems[selectedIndex]} Businesses Report`
                );
              }}
            />
          </div>

          <div className="main_nav">
            {navItems?.map((item, i) => (
              <div
                key={i}
                className={
                  i === selectedIndex ? "main_nav_item_active" : "main_nav_item"
                }
                onClick={() => {
                  setSelectedIndex(i);
                }}
              >
                {item} Businesses
              </div>
            ))}
          </div>

          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search"
            searchVariant="wide"
            totalItems={signedUpBizdata?.data?.count}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />

          {(ViewMoreModal || subscriptionModal || updateBusinessModal) && (
            <div className="modal">
              <AnimatePresence>
                {ViewMoreModal && (
                  <ViewMoreContainer
                    data={data}
                    infoModal={infoModal}
                    setInfoModal={setInfoModal}
                    closeModal={closeModal}
                  />
                )}

                {subscriptionModal && (
                  <GiveSubscriptionContainer
                    closeModal={closeModal}
                    item={data}
                  />
                )}
                {updateBusinessModal && (
                  <UpdateBusinessContainer
                    closeModal={closeModal}
                    item={data}
                  />
                )}
              </AnimatePresence>
            </div>
          )}
          {
            deleteSubdomainUrlModal &&(
              <div className="modal">
                <AnimatePresence>
                  <DeleteSubDomainUrlContainer
                    data={data}
                    closeModal={closeModal}
                  />
                </AnimatePresence>
              </div>
            )
          }
        </div>
      )}
    </AppPage>
  );
};
export default SignedUpBusinesses;
